import styled from 'styled-components';

import { fontSizes } from 'ui/theme';

import { AssociatedEntity } from '../../../../../domain';
import { UserEventDisplay } from './UserEventDisplay';
import { MultipleEventsDisplay } from './MultipleEventsDisplay';
import { ENTITIES } from '../../../constants';

interface UserEventProps {
  events: AssociatedEntity[];
  entityType: ENTITIES;
}

const EventHistoryUserEvent = styled.div`
  font-size: ${fontSizes.s14};
`;

export const UserEvents = ({ events, entityType }: UserEventProps) => {
  const hasMultipleEvents = events.length > 1;

  return (
    <EventHistoryUserEvent data-test="event-history-user-event">
      {hasMultipleEvents ? (
        <MultipleEventsDisplay events={events} entityType={entityType} />
      ) : (
        <UserEventDisplay id={events[0].id} name={events[0].name} />
      )}
    </EventHistoryUserEvent>
  );
};
